import { Box, Text } from '@doda/io-react/common';
import { FC } from 'react';
import { LabelText } from 'components/SearchSideBar/CurrentCondition/labelText';
import style from './index.module.scss';

/** CurrentCondition props*/
interface Props {
  /** 検索条件ラベル */
  searchConditionLabel: string | undefined;
}

export const CurrentCondition: FC<Props> = ({ searchConditionLabel }) => {
  return (
    <Box className={style['current-condition__wrapper']}>
      <div className={style['current-condition__heading']}>
        <Text size="16" weight="bold">
          現在の検索条件
        </Text>
      </div>
      <LabelText searchConditionLabel={searchConditionLabel} />
    </Box>
  );
};
